import { loadStripe } from '@stripe/stripe-js'

import { STRIPE_PUBLISHABLE_KEY } from '_config/environment'

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)
